import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';
import './slick-carousel-counter.js';

function respondToVisibility(element, callback) {
	const options = {
		root: document.documentElement,
	};
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			callback(entry.intersectionRatio > 0);
		});
	}, options);
	observer.observe(element);
}

const DEFAULT_SLICK_CONFIG = {
	centerMode: true,
	arrows: false,
	dots: true,
	slidesToShow: 3,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				arrows: false,
				dots: true,
				centerMode: true,
				slidesToShow: 1,
			},
		},
	],
};

export default class SlickCarousel extends BaseComponent {
	carouselCounter = undefined;

	properties() {
		return {
			dataSlick: undefined,
			listLabelledbyId: '',
			prevArrowLabel: '',
			nextArrowLabel: '',
		};
	}

	connected() {
		this.$element.on('init', (event, slick) => {
			this.improveAccessibility(slick);

			if (slick.originalSettings?.carouselCounterSelector) {
				this.carouselCounter = globalThis.document.querySelector(
					slick.originalSettings?.carouselCounterSelector,
				);
			}

			const slidesToShow = slick.slickGetOption('slidesToShow');
			const slideCount = slick.slideCount;
			this.element.classList.toggle('can-slide', slideCount > slidesToShow);

			this._slick = slick;

			if (this.carouselCounter) {
				this.carouselCounter.slideCount = slick.slideCount;
				this.carouselCounter.slidesToShow = slick.options?.slidesToShow || 1;
			}
			this.dispatch('slick-carousel-init', { slick, $slick: this.$element });
		});

		this.$element.on('afterChange', (event, slick, currentSlide) => {
			this.improveAccessibility(slick);

			if (this.carouselCounter) this.carouselCounter.currentSlide = currentSlide + 1;

			const slidesToShow = slick.slickGetOption('slidesToShow');
			const slideCount = slick.slideCount;
			this.element.classList.toggle('can-slide', slideCount > slidesToShow);
		});

		this.$element.on('breakpoint', (event, slick, breakpoint) => {
			if (this.carouselCounter) this.carouselCounter.slidesToShow = slick?.options?.slidesToShow || 1;
		});

		respondToVisibility(this.element, (visible) => {
			if (visible && !this.element.classList.contains('slick-initialized')) {
				this.$element.slick(this.dataSlick ? this.dataSlick : DEFAULT_SLICK_CONFIG);
			}
		})
	}

	improveAccessibility(slick) {
		// improve accessibility stuff (see: https://github.com/kenwheeler/slick/issues/3268)
		setTimeout(() => {
			if (slick.$slideTrack) {
				slick.$slideTrack.attr('role', 'list');
				if (this.listLabelledbyId !== '') {
					slick.$slideTrack.attr('aria-labelledby', this.listLabelledbyId);
				}
			}

			if (slick.$slides) {
				slick.$slides.each((index, slide) => {
					$(slide).attr('role', 'listitem');
					if (!slide.classList.contains('slick-cloned')) {
						$(slide).attr('aria-hidden', 'false');
					}
				});
			}

			if (slick.$dots) {
				// remove accessibility stuff from dots
				slick.$dots.removeAttr('role');
				slick.$dots.find('li').each((index, li) => {
					$(li).removeAttr('role');
				});
				slick.$dots.find('button').each((index, button) => {
					button.setAttribute('tabindex', '-1');
					button.setAttribute('aria-hidden', 'true');
					$(button).removeAttr('role');
				});
			}

			// set better aria labels for slick-arrows
			if (slick.$prevArrow) {
				slick.$prevArrow.attr('aria-label', this.prevArrowLabel || slick.$prevArrow.attr('aria-label') || '');
			}
			if (slick.$nextArrow) {
				slick.$nextArrow.attr('aria-label', this.nextArrowLabel || slick.$nextArrow.attr('aria-label') || '');
			}
		}, 0);
	}
}

defineComponent('slick-carousel', SlickCarousel);
